import { useEffect, useState } from 'react'
import { Label, Select } from '@/components/ui'
import { useValuationStore } from '@/store/valuationStore'
import { fetchZoneQuotazioni } from '@/services/zone-quotazioni.service'

export function AddressStep() {
  const { formData, updateFormData } = useValuationStore()
  const [zoneOptions, setZoneOptions] = useState<{ value: string; label: string }[]>([])
  const [isLoadingZones, setIsLoadingZones] = useState(true)

  useEffect(() => {
    setIsLoadingZones(true)
    fetchZoneQuotazioni()
      .then((zones) => {
        const names = zones.map((z) => z.nome).sort((a, b) => a.localeCompare(b, 'it'))
        setZoneOptions(names.map((name) => ({ value: name, label: name })))
      })
      .finally(() => setIsLoadingZones(false))
  }, [])

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Dove si trova l'immobile?</h2>
        <p className="mt-1 text-gray-600">
          Seleziona la zona in cui si trova l'immobile
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <Label htmlFor="zoneName" required>
            Zona di riferimento
          </Label>
          <Select
            id="zoneName"
            value={formData.zoneName || ''}
            onChange={(e) => updateFormData({ zoneName: e.target.value || undefined })}
            options={zoneOptions}
            placeholder={isLoadingZones ? 'Caricamento zone...' : 'Seleziona la zona'}
            disabled={isLoadingZones}
          />
          <p className="mt-1 text-sm text-gray-500">
            Seleziona la zona in cui si trova l'immobile per ottenere una valutazione accurata
          </p>
        </div>
      </div>
    </div>
  )
}
